/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { LS_PRICE_ALERTS_KEY } from './Table';
import { compareNumericString } from '../../../helpers/tableSort';

interface ITableWidths {
  ticker: number;
  exchange: number;
  alertPrice: number;
  difference: number;
  status: number;
  actions: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  ticker: 176,
  exchange: 120,
  alertPrice: 110,
  difference: 150,
  status: 150,
  actions: 150,
};

interface IUseTableDataProps {
  alerts: any;
}

const useTableData = ({ alerts }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_PRICE_ALERTS_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => alerts, [alerts]);
  const columns = React.useMemo(
    () => [
      {
        id: 'ticker',
        Header: 'Pair',
        accessor: 'ticker',
        disableSortBy: true,
        width: tableColumnsWidth['ticker'] || tableWidthsDefaultState['ticker'],
      },
      {
        id: 'exchange',
        Header: 'Exchange',
        accessor: 'exchange',
        width:
          tableColumnsWidth['exchange'] || tableWidthsDefaultState['exchange'],
      },
      {
        id: 'alertPrice',
        Header: 'Alert Price',
        accessor: 'price',
        width:
          tableColumnsWidth['alertPrice'] ||
          tableWidthsDefaultState['alertPrice'],
        sortType: compareNumericString('price_usd'),
      },
      {
        id: 'difference',
        Header: 'Difference',
        accessor: 'difference',
        disableSortBy: true,
        width:
          tableColumnsWidth['difference'] ||
          tableWidthsDefaultState['difference'],
      },
      {
        id: 'status',
        Header: 'Status',
        accessor: 'status',
        width: tableColumnsWidth['status'] || tableWidthsDefaultState['status'],
      },
      {
        id: 'actions',
        Header: 'Actions',
        accessor: 'actions',
        disableSortBy: true,
        width:
          tableColumnsWidth['actions'] || tableWidthsDefaultState['actions'],
      },
    ],
    []
  );

  return { columns, data, tableColumnsWidth };
};

export { useTableData };
